import { Skeleton as MUISkeleton } from "@mui/material";
import type { ComponentProps } from "react";

export type SkeletonProps = ComponentProps<typeof MUISkeleton>;

export const Skeleton = (props: SkeletonProps) => {
    return <MUISkeleton {...props} />;
};
